module.exports = __webpack_public_path__ + "img/coin1.ef574c6b.png";